<template>
  <div>
   <lanTrainIntroduction  :game='game' @close2='closeCogn' v-if="game.id<200"></lanTrainIntroduction>
    <cognTrainIntroduction :game='game' @close2='closeCogn' v-else></cognTrainIntroduction>
  </div>
</template>

<script>
  import Vue from 'vue'
  import cognTrainIntroduction from './cognTrainIntroduction.vue'
  import lanTrainIntroduction from './lanTrainIntroduction.vue'
  export default ({
    props:["game"],
    data() {
      return {
        address: GLOBAL.cognition,
        showDialog: true,
        showOver: false,
        saveGame: false,  // 打开1.0游戏并保存
        showMes: false,   // 显示消息框
        gameType: 1,   // 1:认知，2：言语
        gameFlag: 0,      // 0：临时训练； 1：正式训练
        gameData: this.game,       // 游戏数据
        gameScore: {},
        todayGames: '',
        showVerbal:false,
        showplan:true,
      }
    },
    components:{
      lanTrainIntroduction,
      cognTrainIntroduction

    },
    methods: {
      closeCogn:function(){
        //alert(game.id);
        this.$emit("close");
      },
    }
  
  });
</script>

<style scoped>
  .title-style{
    font-size: 12px;
    color: #999;
  }
  .bold-content{
    font-size: 14px;
    font-weight: bold;
  }
  .desc-content{
    font-size: 14px;
  }

</style>
<style>
.diaTrainContent{
  width:768px !important;
  max-width:768px !important;
  height:425px !important;
  max-height:425px !important;
}
.canWidth{
  min-width:150px;
}
</style>




// WEBPACK FOOTER //
// digTrainContentmodal.vue?74055fd6